import React from "react";
import { CharacterSheet, Identidade } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const Identidades: React.FC<Props> = ({ character, onChange }) => {
  const addIdentidade = () => {
    onChange({
      ...character,
      identidades: [
        ...character.identidades,
        { nome: "", sobreposicao: "", efeitos: "" },
      ],
    });
  };

  const removeIdentidade = (index: number) => {
    onChange({
      ...character,
      identidades: character.identidades.filter((_, i) => i !== index),
    });
  };

  const updateIdentidade = (index: number, field: keyof Identidade, value: any) => {
    const newIdentidades = [...character.identidades];
    newIdentidades[index] = { ...newIdentidades[index], [field]: value };
    onChange({ ...character, identidades: newIdentidades });
  };

  return (
    <div className="section">
      <h2>Identidades</h2>
      <div className="form-group">
        <label>Slots Disponíveis</label>
        <input
          type="number"
          value={character.slotsIdentidades}
          onChange={(e) =>
            onChange({
              ...character,
              slotsIdentidades: parseInt(e.target.value) || 0,
            })
          }
          min="0"
        />
      </div>
      <button type="button" onClick={addIdentidade} className="btn-add">
        + Adicionar Identidade
      </button>
      {character.identidades.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Identidade</th>
              <th>Sobreposição</th>
              <th>Efeitos</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {character.identidades.map((identidade, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={identidade.nome}
                    onChange={(e) => updateIdentidade(index, "nome", e.target.value)}
                    placeholder="Nome da identidade"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={identidade.sobreposicao}
                    onChange={(e) => updateIdentidade(index, "sobreposicao", e.target.value)}
                    placeholder="Sobreposição"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={identidade.efeitos}
                    onChange={(e) => updateIdentidade(index, "efeitos", e.target.value)}
                    placeholder="Efeitos"
                  />
                </td>
                <td>
                  <button type="button" onClick={() => removeIdentidade(index)} className="btn-remove">
                    Remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
